<div class="bm--header theme-header">
  <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
    <div class="bm--header-box">
      <!-- Logo -->
      <div class="bm--logo-box" routerLink="/">
        <bmcore-logo [beatmakerName]="beatmakerName" [logoUrl]="logoUrl"></bmcore-logo>
      </div>

      <!-- Links -->
      <ul class="bm--header-links">
        <li
          class="home theme-header__link"
          routerLink="/"
          [ngClass]="{ 'active  theme-header__link--active': checkIsLinkActive('home') }"
        >
          {{ lg.header.home }}
          <div
            class="divider-line"
            [ngClass]="{ 'divider-line--active  theme-header__activeLinkLine': checkIsLinkActive('home') }"
          ></div>
        </li>

        <li
          class="theme-header__link"
          routerLink="/catalog"
          [ngClass]="{ 'active  theme-header__link--active': checkIsLinkActive('catalog') }"
        >
          {{ lg.header.catalog }}
          <div
            class="divider-line"
            [ngClass]="{ 'divider-line--active  theme-header__activeLinkLine': checkIsLinkActive('catalog') }"
          ></div>
        </li>
      </ul>

      <!-- Cart counter -->
      <bmcore-cart-counter [appType]="'PROD-PAGE'"></bmcore-cart-counter>
    </div>
  </div>
</div>
